import { notification } from "ant-design-vue";
import lodash from "lodash";
import { reactive, unref } from "vue";
import { setLocale, state as stateApp } from "../../../app.logic";
import i18n from "../../../i18n";
import router from "../../../router";
import store from "../../../store";
import { has, matchMenu } from "../../../utils/menu-context";
import websocket from "../../../utils/websocket";

export const mapDataItemToMenu = menuSides => {
    return menuSides
        .filter(menuChildren => {
            const menuContext = matchMenu(menuChildren.url, stateApp.authInfo.menus);
            if (menuContext && has({ menuContext, key: "noMenuSide" })) return false;
            return true;
        })
        .map(menu => {
            let title = menu.name;
            const isReleaseMenu = new RegExp("^\\/app\\/release\\/(request|change|cancel)\\/.+$", "g").test(menu?.url);
            if (isReleaseMenu) {
                const menuContext = matchMenu(menu.url, stateApp.authInfo.menus);
                if (menuContext && has({ menuContext, key: "forApprove" }))
                    title += ` / ${i18n.global.t("button.approve")}`
            }
            return {
                id: menu.id,
                path: menu.url,
                meta: {
                    title: title,
                    icon: menu.icon
                },
                children: menu.children.length > 0 ? mapDataItemToMenu(menu.children) : null,
                isShow: menu.children.length > 0 ? mapDataItemToMenuFilterChildren(menu) : true
            };
        });
};

export const mapDataItemToMenuFilterChildren = menu => {
    return (
        menu.children
            .filter(menuChildren => {
                const menuContext = matchMenu(menuChildren.url, stateApp.authInfo.menus);
                if (menuContext && has({ menuContext, key: "noMenuSide" })) return false;
                return true;
            })
            .filter(d => d).length > 0
    );
};

export const onBreakpoint = broken => {
    state.isMobile = broken;
    state.openKeys = [];
    state.selectedKeys = [];
    onCollapsed(broken);
};

export const onCollapsed = collapsed => {
    state.collapsed = collapsed;
    refreshSidebar();
};

export const onClickLogout = () => {
    store.dispatch("resource/auth/logout");
};

export const onClickLocale = locale => {
    setLocale(locale);
};

export const createRoutedMap = (routes, menuSides) => {
    const group = lodash.groupBy(routes, route => route.path);
    routes = Object.keys(group).map(key => {
        const hasTitle = group[key].find(route => route.instances?.default?.title);
        const last = group[key][group[key].length - 1];
        return hasTitle || last;
    });
    return routes
        .map(route => {
            if (route.instances?.default?.title) {
                const currentRoute = unref(router.currentRoute);
                const routePathArr = route.path.split("/");
                const currentRoutePathArr = currentRoute.path.split("/");
                const resultUrl = routePathArr.map((v, index) => currentRoutePathArr[index]).join("/");
                return {
                    url: resultUrl,
                    name: route.instances.default.title
                };
            }
            const routeMenuSides = getMenuByUrl(menuSides, route.path);
            const lastMenuSide = routeMenuSides[routeMenuSides.length - 1];
            if (!lastMenuSide) {
                return false;
            }
            return {
                url: lastMenuSide.path,
                name: lastMenuSide.meta.title
            };
        })
        .filter(route => route);
};

export const getMenuByUrl = (menuSides, url) => {
    for (let i = 0; i < menuSides.length; ++i) {
        const menuSide = menuSides[i];
        if (menuSide.path === url) {
            return [menuSide];
        }
        if (menuSide.children) {
            const currentMenu = getMenuByUrl(menuSide.children, url);
            if (currentMenu.length > 0) {
                return [menuSide, ...currentMenu];
            }
        }
    }
    return [];
};

export const setAppPageHeader = appPageHeader => {
    lodash.merge(state.appPageHeader, appPageHeader);
};

export const refreshSidebar = () => {
    const matched = router.currentRoute.value.matched;
    for (let i = matched.length - 1; i > 0; --i) {
        const ids = getMenuByUrl(state.menuSides, matched[i].path).map(d => d.id);
        if (ids.length) {
            state.selectedKeys = [...ids];
            return;
        }
    }
    state.selectedKeys = [];
};

export const onWebsocketConnect = () => {
    state.websocketSubscribes.push(
        websocket.subscribe(`/user/topic/logout`, () => {
            notification["warning"]({ message: i18n.global.t("views.accountLayout.otherSessionLogin") });
            setTimeout(() => onClickLogout(), 5000);
        })
    );
};

export const state = reactive({
    isLayout: true,
    collapsed: false,
    isMobile: false,
    sidebar: {
        width: "auto",
        collapsedWidth: 0
    },
    menuSides: [],
    openKeys: [],
    selectedKeys: [],
    appPageHeader: {
        slots: {
            default: null
        },
        canBack: true
    },
    _timestamp: new Date().getTime(),
    websocketId: null,
    websocketSubscribes: []
});

export const refs = reactive({
    sider: null,
    header: null
});

export const containerStyle = reactive({
    marginLeft: "0px"
});

export const contentStyle = reactive({
    marginTop: "0px"
});

export const bodyStyle = reactive({
    padding: "0px"
});

export const locales = reactive([
    { title: "EN", value: "en" },
    { title: "TH", value: "th" }
]);
